import { createFileRoute, redirect } from '@tanstack/react-router'
import { OrderFormScreen } from '@/features/purchasing-orders/order-form-screen'
import { hasGrant } from '@/lib/me'

/**
 * Route shell for raising a purchase order (WP05). The grant guard is
 * presentation only: the API enforces `purchase_order.create`.
 */
export const Route = createFileRoute('/_authenticated/purchasing/orders/new')({
  beforeLoad: ({ context }) => {
    if (!hasGrant(context.queryClient, 'purchase_order.create')) {
      throw redirect({ to: '/purchasing/orders' })
    }
  },
  component: OrderFormScreen,
})
